// The CSG wordmark comes in two cuts: white "csg" for dark surfaces and navy
// "csg" for light ones (the "[it]" bracket is Celestial Blue #009CDC in both).
// The rasters are 560px renders of the brand package's csg_wordmark_light /
// csg_wordmark_dark artwork (csg-branding skill, assets/) — the earlier files
// drew the bracket in the off-brand #1598CB. Pick the
// pair that matches the current theme mode so the logo never vanishes into
// the cream background in light mode. The collapsed-sidebar icon is the blue
// bracket alone and needs no swap.
import { useTheme } from './ThemeProvider';
import logoOnDark from '../img/optimized/csg-logo.webp';
import logoOnDarkPng from '../img/optimized/csg-logo.png';
import logoOnLight from '../img/optimized/csg-logo-light.webp';
import logoOnLightPng from '../img/optimized/csg-logo-light.png';

export const CSG_LOGO = {
  dark: { webp: logoOnDark, png: logoOnDarkPng },
  light: { webp: logoOnLight, png: logoOnLightPng },
};

export const useCsgLogo = () => {
  const { isDarkMode } = useTheme();
  return isDarkMode ? CSG_LOGO.dark : CSG_LOGO.light;
};

export default useCsgLogo;
